export const APP_PERMISSIONS = {
  'suite.ghosting': ['GLOBAL_ADMIN'],
  'suite.portal': ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'],
  'suite.live': ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'],
  'suite.analytics': ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'],
  'suite.scheduler': ['GLOBAL_ADMIN'],
  'suite.api': ['GLOBAL_ADMIN', 'API_USER', 'OPERATOR', 'VIEWER'],
  'suite.devices': ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'],
  'suite.education': ['GLOBAL_ADMIN', 'API_USER', 'OPERATOR', 'VIEWER'],
  'suite.vips': ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'],
  'suite.prepaid_pass_manager': ['GLOBAL_ADMIN'],
  'suite.provisioning': ['GLOBAL_ADMIN'],
  'suite.users': ['GLOBAL_ADMIN'],
  'suite.network_diagram': ['GLOBAL_ADMIN'],
  'suite.signal': ['GLOBAL_ADMIN'],
  'suite.onboarding': ['GLOBAL_ADMIN'],
  'suite.access_control': ['GLOBAL_ADMIN'],
  'suite.business_intelligence': ['GLOBAL_ADMIN']
};

/**
  * Check for user role
  * @param {Object} user
  * @param {string[]} allowedRoles
  * @returns {boolean}
  */
export function checkRole(user, allowedRoles) {
  const roles = user?.g?.map(org => org.r) || [];
  return roles?.some(role => allowedRoles?.includes(role));
}

/**
 * Check if path string or substrings are or included in role's allowed features
 * @param {Object} authUser
 * @param {!string} path dot notated feature path
 * @returns {boolean}
 */
export function hasRoleAccess(authUser, path) {
  if (!path) {
    throw new Error('no feature provided to check permissions for');
  }

  // Split the path into segments
  const segments = path.split('.');

  // Generate all possible paths from the segments
  const allowed = segments.map((_, i) => segments.slice(0, i + 1).join('.'));

  // Check if any of the generated paths are included in the user's allowed permissions
  const found = allowed.find(key => APP_PERMISSIONS[key] && checkRole(authUser, APP_PERMISSIONS[key]));

  // Return true if any of the generated paths were found
  return Boolean(found);
};
